import React from "react";
import Modal from "../../../shared/components/ui/Modal";

const ReleaseConfirmModal = ({
  show,
  number,
  onCancel,
  onConfirm,
  processing = false,
}) => {
  return (
    <Modal
      show={show}
      onClose={onCancel}
      header={
        <h2 className="text-lg font-bold text-danger">Delete Number</h2>
      }
      description={
        <p className="text-sm text-muted">
          This will permanently delete the number. This action cannot be
          undone.
        </p>
      }
      footer={
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            disabled={processing}
            className="px-5 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(number)}
            disabled={processing}
            className="px-5 py-2 bg-danger text-white rounded-lg text-sm font-bold tracking-wider hover:bg-dangerHover transition-colors"
          >
            {processing ? "Deleting..." : "Delete"}
          </button>
        </div>
      }
    >
      {number && (
        <div className="bg-dangerLight rounded-xl p-4 space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted">Number</span>
            <span className="font-semibold text-primary">
              {number.phoneNumber || "-"}
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted">Nickname</span>
            <span className="text-content">{number.nickname || "-"}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted">Greeting</span>
            <span className="text-content">{number.greetingFile || "-"}</span>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ReleaseConfirmModal;
